import { useEffect, useMemo, useState } from "react";
import { apiGet } from "../api/client";
import { ymdTodayLocal } from "../utils/dateUtils";

type Limits = {
  max_date?: string | null;
  max_future_date?: string | null;
};

export function useReportDateLimits(companyId?: string) {
  const today = ymdTodayLocal();
  const [limits, setLimits] = useState<Limits>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let alive = true;

    // ✅ DO NOT bail when companyId is ""/undefined.
    // Report endpoints are usually company-scoped by auth/context anyway.
    (async () => {
      setLoading(true);
      try {
        const r = await apiGet<Limits>("/reports/date-limits");
        if (!alive) return;
        setLimits(r || {});
      } catch {
        if (alive) setLimits({});
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [companyId]); // keep this so switching companies refetches limits

  const reportMaxYmd = useMemo(() => {
    // ✅ Prefer max_future_date if backend provides it
    const md = ((limits?.max_future_date || limits?.max_date || "") as string).trim();
    return md && md > today ? md : today;
  }, [limits, today]);

  return { today, reportMaxYmd, limits, loading };
}